export default "__VITE_ASSET__033cddcd__"